import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
//import authentication from "react-azure-b2c";
import { Provider } from "react-redux";
import store from "./redux/store";
import jwt_decode from "jwt-decode";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.handleRedirectPromise().then((tokenResponse) => {
  //console.log(tokenResponse)
  localStorage.setItem("AccessToken", tokenResponse.accessToken)
  const decoded = jwt_decode(tokenResponse.accessToken);
  localStorage.setItem("CareCode", decoded.streetAddress);
}).catch((error) => {
  
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  //<React.StrictMode>
    <Provider store={store}>
      <App msalInstance={msalInstance}/>
    </Provider>
  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
